const messages = {
    menuTitle: 'Klienci',
    pageTitle: 'Klienci',
    createCustomerPageTitle: 'Klienci / Nowy klient',
    editCustomerPageTitle: 'Klienci / Edycja klienta',

    common: {
        tooltips: {
            edit: 'Edycja',
            delete: 'Usuń',
            deleteAddress: 'Usuń Adres',
            deleteContact: 'Usuń kontakt'
        },
        buttons: {
            save: 'Zapisz',
            cancel: 'Anuluj',
            backToList: 'Powrót do listy',
            addAddress: 'Dodaj adres'
        },
        actions: 'Akcje'
    },

    actions: {
        add: 'Dodaj klienta',
        showAll: 'Pokaż wszystkich'
    },

    filters: {
        filterByNIP: 'Szukaj po NIP',
        filterByName: 'Szukaj po nazwie'
    },

    fields: {
        companyName: 'Nazwa firmy',
        nip: 'NIP',
        customerType: 'Typ klienta',
        isActive: 'Czy aktywny?',
        multiplySignalAmountByProcesses: 'Mnóż sygnalne przez liczbę procesów',
        street: 'Ulica',
        postCode: 'Kod pocztowy',
        city: 'Miasto',
        country: 'Kraj',
        addressType: 'Typ adresu',
        order: 'Kolejność',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        phoneNumber: 'Numer telefonu',
        email: 'Email',
        notes: 'Uwagi',
        selectFlow: 'Wybierz flow'
    },

    sections: {
        customerData: 'Dane klienta',
        addresses: 'Adresy',
        contacts: 'Kontakty',
        billboards: 'Billboardy',
        flowName: 'Nazwa:',
        flowGroup: 'Grupa:',
        flowAcronym: 'Akronim:'
    },

    placeholders: {
        noCustomerTypeFound: 'Nie znaleziono typu klienta',
        noCountryFound: 'Nie znaleziono kraju',
        noAddressTypeFound: 'Nie znaleziono typu adresu',
        noAddresses: 'Brak adresów.',
        noContacts: 'Brak kontaktów.',
        noFlow: 'Brak flow dla klienta.'
    },

    dialogs: {
        deleteCustomer: {
            title: 'Usuwanie klienta',
            message: 'Czy na pewno chcesz usunąć klienta {name}',
            confirmButton: 'Usuń'
        },
        deleteAddress: {
            title: 'Usuwanie adresu',
            message: 'Czy na pewno chcesz usunąć adres?',
            confirmButton: 'Usuń'
        },
        deleteContact: {
            title: 'Usuwanie kontaktu',
            message: 'Czy na pewno chcesz usunąć kontakt?',
            confirmButton: 'Usuń'
        },
        address: {
            titleNew: 'Nowy adres',
            titleEdit: 'Edycja adresu'
        },
        contact: {
            titleNew: 'Nowy kontakt',
            titleEdit: 'Edycja kontaktu'
        }
    },

    validation: {
        nameRequired: 'Proszę podać nazwę',
        nipRequired: 'NIP jest wymagany',
        nipMaxLength: 'NIP może zawierać maksymalnie 256 znaków',
        nipAlphaNum: 'NIP może zawierać tylko litery i cyfry',
        customerTypeRequired: 'Typ klienta jest wymagany',
        companyNameRequired: 'Proszę podać nazwę firmy.',
        streetRequired: 'Proszę podać ulicę.',
        postCodeRequired: 'Proszę podać kod.',
        cityRequired: 'Proszę podać miasto.',
        countryRequired: 'Proszę wybrać kraj.',
        addressTypeRequired: 'Proszę wybrać typ adresu.',
        orderRequired: 'Proszę podać dodatnią liczbę całkowitą.',
        firstNameRequired: 'Proszę podać imię.',
        lastNameRequired: 'Proszę podać nazwisko.',
        phoneNumberRequired: 'Proszę podać numer telefonu.',
        emailRequired: 'Proszę podać adres email.',
        emailFormat: 'Proszę podać poprawny format dla adresu email.',
        formErrors: 'Proszę poprawić błędy w formularzu.'
    },

    notifications: {
        customerCreated: 'Utworzono klienta.',
        customerUpdated: 'Klient został zedytowany.',
        customerDeleted: 'Klient został usunięty.',
        customerCreationSuccess: 'Dodano nowego klienta.',
        customerCreationError: 'Dodanie nowego klienta nie powiodło się.',
        customerEditionError: 'Edycja klienta nie powiodła się.',
        customerUpdateError: 'Zapis klienta nie powiódł się.',
        customerDeleteError: 'Usunięcie klienta nie powiodło się.',
        fetchCustomerError: 'Nie udało sie pobrać danych klienta.',
        fetchCustomersError: 'Nie udało sie pobrać danych klientów.',
        fetchCustomersSuccess: 'Pobrano dane.',
        fetchCustomerDataError: 'Nie pobrano danych.',
        fetchAddressesError: 'Pobranie adresów klienta nie powiodło się.',
        fetchCustomerTypesError: 'Pobranie typów klientów nie powiodło się.',
        fetchAddressTypesError: 'Pobranie typów adresów nie powiodło się.',
        fetchCountriesError: 'Pobranie krajów nie powiodło się.',
        fetchFlowError: 'Pobranie flow nie powiodło się.'
    }
}

export default {
    messages,
    locale: 'pl'
}
